import React from "react";
import Im from "immutable";
import { useParams } from "react-router-dom";

import { rpName } from "storybook-dashboard/dashboard/project/reportStatus";

export const getTerm = (term, props) => {
  let { tenant_meta } = props;
  let term_map = (tenant_meta || Im.Map()).get("term_map") || Im.Map();
  return term_map.get(term) || term;
};

const getDisciplineOptions = (disciplines) => {
  if (!disciplines) {
    return [];
  }
  return disciplines
    .toList()
    .map((element, i) => (
      <option key={i} value={element.get("base_uid")}>
        {element.get("name")}
      </option>
    ))
    .unshift(<option key={-1} value={""} />)
    .toArray();
};

const getReportingPeriodOptions = (projectReportingPeriods) => {
  if (!projectReportingPeriods) {
    return [];
  }
  return projectReportingPeriods
    .toList()
    .sortBy((i) => i.get("startDate"))
    .map((item, i) => (
      <option key={i} value={item.get("uid")}>
        {rpName(item)}
      </option>
    ))
    .unshift(<option key={-1} value={""} />)
    .toArray();
};

export function setNewWorkPackageFields(fields, disciplines, projectReportingPeriods) {
  let setFields = Object.assign({}, fields);
  setFields.latest_commit__discipline.options = getDisciplineOptions(disciplines);
  setFields.latest_commit__reporting_period.options = getReportingPeriodOptions(projectReportingPeriods);
  return setFields;
}

export function nestDunderKeys(data) {
  let nestedData = {};
  for (let [key, value] of Object.entries(data)) {
    let parts = key.split("__");
    let _key = parts[0];
    let _nest_key = parts.slice(1).join("__");
    nestedData[_key] = _nest_key ? nestDunderKeys({ ...nestedData[_key], [_nest_key]: value }) : value;
  }
  return nestedData;
}

export const useIsCurrent = ({ id }) => {
  const { _companyId, _projectId, _refId } = useParams();
  if (!id) return false;
  const _id = id?.substring(0, 8);
  if (_id == _refId) return true;
  if (_id == _projectId && !_refId) return true;
  if (_id == _companyId && !_projectId && !_refId) return true;
  return false;
};
